import React from 'react'
import { Button } from '@/components/ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { useSelector } from 'react-redux'
import { RootState } from '@/redux/store'
import { UserRole, EndGameMode } from '@/constants/room'

interface EndGameButtonProps {
  onEndGame: () => void
  disabled?: boolean
  mode?: EndGameMode
}

export const EndGameButton: React.FC<EndGameButtonProps> = ({
  onEndGame,
  disabled = false,
  mode = EndGameMode.Game,
}) => {
  const user = useSelector((state: RootState) => state.user.user)

  if (user?.role !== UserRole.Professor) {
    return null
  }

  const isSimulation = mode === EndGameMode.Simulation
  const buttonText = isSimulation ? 'End Pilot' : 'End Game'
  const disabledTooltip = isSimulation
    ? 'Pilot is ending...'
    : 'Game is already ending...'
  const enabledTooltip = isSimulation
    ? 'End the pilot and reset the game - all pilot data will be deleted'
    : 'End the current game session - this action cannot be undone'

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            onClick={onEndGame}
            disabled={disabled}
            className='bg-red-600 hover:bg-red-700 text-white'
          >
            <div className='flex gap-2 items-center'>
              <span className='text-white text-base'>{buttonText}</span>
            </div>
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>{disabled ? disabledTooltip : enabledTooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
